import axios from "axios";
import {authHeader} from "./authHeader";

const API_URL =  process.env.REACT_APP_API_URL;

   
  
const getService = (params) => {
  return axios.get(API_URL + '/api/services', { 
    params: params,
    headers: authHeader() });
};

const getServiceById = async (id) => {
  const response = await axios.get(API_URL +`/api/services/${id}`, {  
    headers: authHeader()
  });
  return response;
};

const addService = async (formData) => {
  const response = await axios.post(API_URL + "/api/services", formData, {  
    headers: authHeader()
  });
  return response.data;
};

const deleteService= async (id) => {
  const response = await axios.delete(API_URL +`/api/services/${id}`,{ headers:authHeader()});
  return response;
};


const updateService = async (id,formData) => {
  const response = await axios.put(API_URL + `/api/services/${id}`, {...formData }, {
    headers: authHeader()
  });
  return response.data; 
};


const SERVICEAPI={
  getService,
  addService,
  deleteService,
  updateService,
  getServiceById
}

export default SERVICEAPI;